module.exports = __webpack_public_path__ + "static/media/technician.de3bd7ba.png";